module.exports = __webpack_public_path__ + "img/img01.5fcd167e.jpg";